<template>
  <v-row class="py-12">
    <v-col sm="12" lg="10" offset-lg="1" md="8" offset-md="1">
      <h2 class="secondary--text my-4">
        <SvgIcon
          height="25px"
          width="25px"
          :iconType="'icon_account_settings'"
          class="secondary--text mr-3"
        />{{
          $t('portal.general.account_settings.account_settings.labels.title')
        }}
      </h2>
      <v-tabs background-color="transparent" v-model="tab">
        <v-tab class="text-capitalize px-8">{{
          $t(
            'portal.general.account_settings.account_settings.labels.tab_configuration'
          )
        }}</v-tab>
      </v-tabs>
      <v-divider></v-divider>
      <v-tabs-items v-model="tab" class="mt-5">
        <v-tab-item>
          <CompanyConfig />
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import { SvgIcon } from '@leapsight/styleguide'
import CompanyConfig from './CompanyConfig'

export default {
  name: 'AccountSettings',
  components: {
    SvgIcon,
    CompanyConfig
  },
  props: {},
  data() {
    return {
      tab: null
    }
  },
  methods: {},
  computed: {},
  watch: {}
  // Lifecycles
}
</script>

<style lang="scss" scoped></style>
